import { Environment } from '~/types/EnvironmentTypes'
import { getApiEnvironment } from '~/utils/common'

const urls = {
  // Endpoints
  REFRESH_TOKEN: '/api/token/refresh/',
  LOGIN: '/api/token/',
  VOICEMAIL_LIST: '/api/v3/voicemail',
  CALL_LIST: '/api/v3/callhistory',
  SEND_FAX: '/faxes/',
  GROUPS: '/api/groups',
  THREADS: '/api/threads',
  GROUP_MESSAGE: '/api/messages',
  EXTENSIONS: '/extensions/',
  GET_PHONENUMBERS: '/api/phone_numbers',
  // New Endpoints
  GET_SNIPPETS: '/message-snippets/',
  MESSAGE_THREADS: '/message-threads/',
  MESSAGE_GROUPS: '/message-groups/',
  GET_MESSAGES: '/messages/',
  GET_PBXES: '/pbxes/',
  GET_PBX_USERS: '/users/select/',
  VOICEMAILS: '/voicemails/',
  FAXES: '/faxes/',
  SECURE_FAX_STATUS: '/v1/secure-faxes/{token}/',
  SECURE_FAX_DOWNLOAD: '/v1/secure-faxes/{token}/download/',
  PHONE_NUMBERS: '/phone-numbers/',
  CONTACTS: '/contacts/',
  CONTACT_SOURCES: '/contact-sources/',
  RECENT_CALLS: '/call-logs/',
  CALLS: '/calls/',
  MISSED_CALLS: '/app/v1/missed-calls/',
  CALL_TRANSCRIPTS: '/call-transcripts/',
  TRANSCRIBED_CALLS: '/call-transcripts-by-pbx/',
  CALL_TRANSCRIPT: '/call-transcripts-by-pbx/{pbxId}/entry/{callId}/',
  BLOCKED_NUMBERS: '/blocked-numbers/',
  QUEUE_AGENT_STATUS: '/extensions/{extensionId}/call-queues/agent/',
  QUEUE_LOG_IN: '/extensions/{extensionId}/call-queues/log-in/',
  QUEUE_LOG_OUT: '/extensions/{extensionId}/call-queues/log-out/',
  EXTENSIONS_SELECT: '/extensions/select/',
  REPORTING_CALLS: '/app/v1/reporting/calls/',
  // External links
  FEEDBACK:
    'https://docs.google.com/forms/d/e/1FAIpQLSfUejJyGSf-7vVwDlCYT66uz73FgAGb9fBg2V0zv_XEH0W94Q/viewform',
  CONTACTUS: 'https://mangovoice.com/contact/',
  SUPPORT: 'https://mangovoice.com/support',
  HELP_CENTER: 'https://support.mangovoice.com/',
  MMS_SUPPORT: 'https://support.mangovoice.com/',
  FAX_SUPPORT: 'https://support.mangovoice.com/',
  get ADMIN() {
    const apiEnv = getApiEnvironment()
    const isUK = apiEnv === Environment.PRODUCTION_UK
    return isUK
      ? 'https://admin.mangovoice.co.uk'
      : 'https://admin.mangovoice.com'
  },
  get FORGOT() {
    const apiEnv = getApiEnvironment()
    const isUK = apiEnv === Environment.PRODUCTION_UK
    return isUK
      ? 'https://admin2.mangovoice.co.uk/reset-password/'
      : 'https://admin2.mangovoice.com/reset-password/'
  },
  UPGRADE: 'https://mangovoice.com/upgrade/',
  DESKTOP_APP_DOWNLOAD: 'https://mangovoice.com/desktop-app/',
}

export default urls
